<template>
  <el-select
    v-model="value"
    filterable
    :placeholder="placeholder"
    :loading="loading"
    clearable
    @clear="$emit('clear')"
    @change="returnParentIds">
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.text"
      :value="item.id"
      style="height:inherit;">
    </el-option>
  </el-select>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import channelModel from '@/framework/models/channelModel'
export default {
  name: 'employee-select',
  extends: BasicPager,
  data () {
    return {
      options: [],
      value: null,
      loading: false
    }
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择员工'
    },
    departmentType: {
      type: Number,
      default: null
    }

  },
  created () {
    let _this = this
    let listener = {
      success: function (dataInfo) {
        _this.options = dataInfo.datas
        _this.loading = false
      }
    }
    _this.loading = true
    _this.loadData(listener)
  },
  methods: {
    setValue: function (val) {
      // 外部调用者设置回显值
      this.value = val
    },
    clear: function () {
      this.value = null
    },
    loadData: function (listener) {
      let that = this

      let param = {
        departmentType: that.departmentType
      }
      channelModel.findEmployees(that, param, listener)
    },
    returnParentIds () {
      let _this = this
      let options = this.options
      let value = _this.value
      for (var i = 0; i < options.length; i++) {
        let option = options[i]
        if (option.id === value) {
          _this.$emit('onEmployeeSelected', option)
          return
        }
      }
    }

  }
}
</script>
